let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("yyYVH")).then(() => parcelRequire('Xr4ik'));